import classNames from 'classnames';
import { Championship } from 'modules/tournaments/domain/interfaces/responce-dto';
import MainComponentsEmptyListMessage from 'modules/tournaments/ui/components/empty-message';
import TourneyComponentsTourneyCard from 'modules/tournaments/ui/components/tourney-card';
import * as S from 'modules/tournaments/ui/components/tourneys-body/styles';
import { TourneysBodySkeleton } from 'modules/tournaments/ui/components/tourneys-body/tourneys-body-skeleton';
import React from 'react';
import UDPagination from 'ud-ui/components/pagination';
import { TourneyEncoded } from '../../../domain/interfaces/tourney-encoded';

type TourneysBodyProps = {
  filters: any;
  tourneys: Championship[];
  pages: number;
  onDetail: (id: TourneyEncoded['id']) => any;
  onPageChange: (page: number) => any;
  isLoading?: boolean;
};

export const TournamentsBody = (props: TourneysBodyProps) => {
  const { filters, tourneys, pages, onDetail, onPageChange, isLoading } = props;
  const isEmpty = !tourneys.length;

  if (isLoading) {
    return <TourneysBodySkeleton resultsOnPage={filters.perPage} className={'relative z-1'} />;
  }

  return (
    <>
      <S.ListContainer
        className={classNames('relative z-1 flex w-full flex-col px-6', {
          empty: isEmpty,
        })}
      >
        <div className="grid grid-cols-12 gap-3">
          {tourneys.map((tourney) => (
            <div className="col-span-4" key={tourney.id}>
              <TourneyComponentsTourneyCard
                key={tourney.id}
                tourney={tourney}
                containerProps={{ className: 'item' }}
                onClickCard={onDetail}
              />
            </div>
          ))}
        </div>
        {isEmpty && <MainComponentsEmptyListMessage className={'flex-center flex-1'} />}
      </S.ListContainer>

      {!isEmpty && (
        <UDPagination
          className="relative z-1 my-8 justify-start px-6"
          pages={pages}
          currentPage={filters.page}
          onPageChange={onPageChange}
        />
      )}
    </>
  );
};
